import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommentsService } from 'src/app/components/comments/comments.service';
import { CommentInterface } from 'src/app/components/comments/types/comment.interface';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { PersonService } from 'src/app/services/person.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Modal } from 'node_modules/bootstrap';
declare var $: any;

@Component({
  selector: 'app-admcomment-list',
  templateUrl: './admcomment-list.component.html',
  styleUrl: './admcomment-list.component.scss'
})

export class AdmcommentListComponent implements OnInit {

  form: FormGroup;
  comments = [];
  filteredComments = [];
  allComments = [];

  constructor(
    private commentService: CommentsService,
    private tier1Service: Tier1Service,
    private personService: PersonService,
    private fb: FormBuilder,
    private fbreply: FormBuilder,
    private tokenStorageService: TokenStorageService
  ) { }

  ngOnInit() {
    this.createFormReply();
    this.createFormCombo();
    this.getTier1ForCombo();
    this.getInactiveComments()
  }

  createFormCombo() {
    this.form = this.fb.group({
      idtier1: [null],
    })
  }

  filterComments(query: string) {
    const searchTerm = query.toLowerCase().trim();
    this.filteredComments = this.allComments.filter(comment =>
      (comment.body?.toLowerCase().includes(searchTerm) ||
        comment.longtitle?.toLowerCase().includes(searchTerm))
    );
  }

  status: boolean = false;
  getInactiveComments() {
    this.commentService.getInactiveComments().subscribe({
      next: res => {
        this.allComments = res['data'];
        this.comments = [...this.allComments];
        this.filteredComments = [...this.comments];
        this.status = this.comments.length > 0;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  /* Comentarios por campo de interes */
  idtier1 = '';
  getAllComments4T(val) {
    if (val.value) {
      this.idtier1 = val.value;
    } else {
      this.idtier1 = val
    }

    this.commentService.getAllComments4tier1(this.idtier1).subscribe({
      next: res => {
        this.comments = res['data'];
        this.filteredComments = [...this.comments];
        this.status = this.comments.length > 0;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  tier1 = [];
  getTier1ForCombo() {
    this.tier1Service.getAll4ComboComment().subscribe({
      next: res => {
        this.tier1 = res['data']
      },
      error: err => {
        console.log(err);
      }
    })
  }


  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  editStatusComment(id: string, status: string, email: string) {

    var text = " ";

    if (status === '1') {
      text = "Esta seguro que desea activar el comentario de :";
    } else if (status === '2') {
      text = "Esta seguro que desea rechazar el comentario de :";
    }

    const data = { status: status }

    if (confirm(text + ' ' + email)) {
      this.commentService.editCommentStatus(id, data).subscribe({
        next: res => {
          if (this.idtier1 === '') {
            this.getInactiveComments();
          } else {
            this.getAllComments4T(this.idtier1);
          }
        },
        error: err => { console.log("Comentario editado"); }
      })
    }

  }

  /* --------------------------logica del modal---------------------------- */

  respuesta: CommentInterface = null
  tempDataComment: CommentInterface = null
  replyModal: Modal | undefined;
  formdata: FormGroup
  edit: boolean = false;

  createFormReply() {
    this.formdata = this.fbreply.group({
      id: [''],
      body: [''],
      tier3Id: [''],
      userId: [''],
      parentId: [''],
      createdAt: ['']
    });
  }

  userIdTS: string;
  openModalReply(respuesta: CommentInterface) {
    this.tempDataComment = respuesta
    /* Conseguir id de persona */
    this.personService.getOneByUserId(this.tokenStorageService.getUser().id).subscribe({
      next: res => {
        this.userIdTS = res['0'].id;
      },
      error: err => {
        console.log(err);
      }
    })
    this.open();
  }

  loadData() {
    this.formdata.reset(this.respuesta);
  }

  save() {
    if (this.formdata.invalid) {
      return Object.values(this.formdata.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.formdata.value.id, this.formdata.value) : this.create(this.formdata.value);
    }
  }

  create(respuesta: CommentInterface) {
    delete respuesta.id;
    var data = { status: 1 };

    respuesta.userId = this.userIdTS;
    respuesta.tier3Id = this.tempDataComment.tier3Id

    if (this.tempDataComment.parentId !== null) {
      respuesta.parentId = this.tempDataComment.parentId
    } else {
      respuesta.parentId = this.tempDataComment.id
    }

    this.commentService.editCommentStatus(this.tempDataComment.id, data).subscribe({
      next: res => {

        this.commentService.replyCommentAdm(respuesta).subscribe({
          next: res => {
            this.clearFormReply();
            this.replyModal.toggle();
            if (this.idtier1 === '') {
              this.getInactiveComments();
            } else {
              this.getAllComments4T(this.idtier1);
            }
          },
          error: err => {
            console.log(err);
          }
        })
      },
      error: err => {
        console.log(err);
      }
    });
  }

  clearFormReply() {
    this.formdata.reset();
  }

  update(id: string, respuesta: CommentInterface) {
    delete respuesta.id;
  }


  /*   cargamos lo datos seleccionado para el modal */
  changeModel() {
    this.open();
  }

  /*   Metodo para abrir el modal */
  open() {
    this.replyModal = new bootstrap.Modal(document.getElementById('replyModal'), {
      keyboard: false
    });
    this.replyModal.show();
  }
  /* --------------------------Fin logica del modal---------------------------- */
}
